import FeatureReductionCluster from '@arcgis/core/layers/support/FeatureReductionCluster';
import * as pieChartRendererCreator from '@arcgis/core/smartMapping/renderers/pieChart.js';
import { outagesPointLayer } from '../layers/outages.layer';

export async function generateClusterConfig() {
  const { renderer, fields } = await pieChartRendererCreator.createRendererForClustering({
    layer: outagesPointLayer,
  });

  const plannedField = fields.find(field => field.name === 'SUM_Planned');
  if (plannedField) {
    plannedField.onStatisticExpression.expression = `
      When($feature.avbruddstype == "Planned", Number($feature.antallkunder), 0)
    `;
  }

  const unplannedField = fields.find(field => field.name === 'SUM_Unplanned');
  if (unplannedField) {
    unplannedField.onStatisticExpression.expression = `
      When($feature.avbruddstype == "Unplanned", Number($feature.antallkunder), 0)
    `;
  }

  return {
    type: 'cluster',
    renderer,
    clusterRadius: '144px',
    clusterMinSize: '56px',
    fields: [
      ...fields,
      {
        name: 'antallkunder_sum',
        alias: 'Total population',
        onStatisticField: 'antallkunder',
        outStatisticFieldName: 'antallkunder_sum',
        statisticType: 'sum',
      },
    ],
    labelingInfo: [
      {
        deconflictionStrategy: 'none',
        labelExpressionInfo: {
          expression: `Text($feature.antallkunder_sum)`,
        },
        labelPlacement: 'center-center',
        symbol: {
          type: 'text',
          color: '#000',
          haloColor: '#fff',
          haloSize: 1.5,
          font: {
            family: 'sans-serif',
            size: 14,
            weight: 'bold',
          },
        },
      },
    ],
  } as unknown as FeatureReductionCluster;
}
